import { render, staticRenderFns } from "./DownloadsDropdown.vue?vue&type=template&id=1af3923b&scoped=true&"
import script from "./DownloadsDropdown.vue?vue&type=script&lang=js&"
export * from "./DownloadsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DownloadsDropdown.vue?vue&type=style&index=0&id=1af3923b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3923b",
  null
  
)

export default component.exports